export const gas = {
    send: 300000,
    vote: 1000000,
    delegate: 300000,
    un_delegate: 300000,
    re_delegate: 400000,
    claim_reward: 350000,
};
